import React from 'react';
interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}
export const Container: React.FC<ContainerProps> = ({
  children,
  className = ''
}) => {
  return <div className={`w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 prose-lg prose-invert 
        [&_p]:leading-relaxed [&_p]:text-gray-300 
        [&_h1]:leading-tight [&_h2]:leading-tight [&_h3]:leading-tight
        [&_h1]:max-w-[20ch] [&_h1]:mx-auto
        [&_p]:max-w-[65ch] [&_p]:mx-auto
        ${className}`} data-id="element-711">
      {children}
    </div>;
};